import React from "react";
import SidebarObject from "./Component";
import { observer } from "mobx-react";

type SidebarQuizzerContainerProps = {
    children: any;
    subject: any;
    hasCreateAccess: boolean;
    
};

const SidebarQuizzerContainer = observer(
    ({
        children,
        subject,
    }: SidebarQuizzerContainerProps) => {
        return <SidebarObject children={children} subject={subject} />;
    }
);

export default SidebarQuizzerContainer;
